import React, { useEffect } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { Session } from './utils/session';

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const interval = setInterval(() => {
      if (!Session.isAuthenticated()) {
        navigate("/login", { replace: true, state: { from: location } });
      }
    }, ); 

    return () => clearInterval(interval);
  }, [navigate, location]);

  if (!Session.isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
};

export default ProtectedRoute;
